import BackButton from "components/Button/BackButton"
import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import Dropdown from "components/Input/Dropdown"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { EmptyString, FormTypeAdd, FormTypeEdit, StatusCodeActive, StatusCodeDelete } from "utils/Constant"
import { decimal } from "utils/helpers"
import UnDeleteButton from "components/Button/UnDeleteButton"
import Select from 'react-select'
import { useModal } from "context/ModalContext"
import { useCallApi } from "api/apiHooks"
import { FormCard, PagesFormTitle } from "components/Cards"

export default function EDCForm(){
    const navigate = useNavigate()
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchBankList, fetchInsertEdc, fetchUpdateEdc, fetchDeleteEdc, fetchEdcById, fetchCommon, fetchBeneficiaryList } = useCallApi()

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramEdcId = queryString.get("edcId")

    const [bankId, setBankId] = useState(EmptyString)
    const [bankOptions, setBankOptions] = useState([])
    const [edcName, setEdcName] = useState(EmptyString)
    const [mdrOn, setMdrOn] = useState(EmptyString)
    const [mdrOff, setMdrOff] = useState(EmptyString)
    const [mdrQrisOn, setMdrQrisOn] = useState(EmptyString)
    const [mdrQrisOff, setMdrQrisOff] = useState(EmptyString)
    const [beneficiaryOptions, setBeneficiaryOptions] = useState([])
    const [beneficiaryId, setBeneficiaryId] = useState(EmptyString)
    const [edcTypeOptions, setEdcTypeOptions] = useState([])
    const [edcType, setEdcType] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)
    

    const beneficiaryOnInput = (e) => { 
        fetchBeneficiaryList(
            EmptyString,
            e, 
            bankId === EmptyString ? "0" : bankId,
            status,
            100000,
            0
        ).then((res) => {
            if (res.data.listData.length > 0){
                let data = res.data.listData
                let tempArray = []

                for (let i = 0; i < data.length; i++){
                    tempArray.push({ label: data[i].accountName + " - " + data[i].bankCode + " (" + data[i].accountNo + ")", value: String(data[i].beneficiaryId) })
                }

                setBeneficiaryOptions(tempArray)
            }
        })
    }

    const saveBtnClick = async () => {
        if (validateForm()){
            const isConfirmed = await confirm()

            if (isConfirmed) {
                showLoading()

                try {
                    if (formType === FormTypeAdd){
                        const res = await fetchInsertEdc(
                            bankId,
                            edcName,
                            "0",
                            mdrOn,
                            mdrOff,
                            mdrQrisOn,
                            mdrQrisOff,
                            beneficiaryId.value,
                            edcType
                        )

                        if (!res) return

                        showSuccess({
                            onSuccess: () => {
                                navigate("/setting/edc")
                            }
                        })
                    }else{
                        const res = await fetchUpdateEdc(
                            paramEdcId,
                            bankId,
                            edcName,
                            "0",
                            mdrOn,
                            mdrOff,
                            mdrQrisOn,
                            mdrQrisOff,
                            beneficiaryId.value,
                            edcType
                        )

                        if (!res) return

                        showSuccess({
                            onSuccess: () => {
                                navigate("/setting/edc")
                            }
                        })
                    }
                } finally {
                    hideLoading()
                }
            }
        }
    }
    const deleteBtnClick = async () => {
        const isConfirmed = await confirm()

        if (isConfirmed) {
            showLoading()

            const res = await fetchDeleteEdc(paramEdcId, status)

            if (!res) return

            showSuccess({
                onSuccess: () => {
                    navigate("/setting/edc")
                }
            })
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    function validateForm(){
        let errorCount = 0

        if (errorCount > 0){
            return false
        }else{
            return true
        }
    }

    useEffect(() => {
        showLoading()

        const loadData = async () => {
            showLoading()

            try {
                // Get Bank List
                const res = await fetchBankList('', '', '1', 1000, 0)
                if (!res) return

                let data = res.data.listData
                let tempArray = []

                tempArray.push({ label: "Select Bank", value: "0" })

                for (let i = 0; i < data.length; i++){
                    tempArray.push({ label: data[i].bankCode + " - " + data[i].bankName, value: String(data[i].bankId) })
                }

                setBankOptions(tempArray)
                setBankId(tempArray[0].value)

                // Get EDC Type List
                const res2 = await fetchCommon("edc_type_options")
                if (!res2) return

                if (res2.data.length > 0){
                    let data = res2.data
                    let tempArray = []

                    for (let i = 0; i < data.length; i++){
                        tempArray.push({ label: data[i].commonText, value: String(data[i].commonValue) })
                    }

                    setEdcTypeOptions(tempArray)
                }

                // If Form Type Edit, Get EDC Detail
                if (formType === FormTypeEdit){
                    const res3 = await fetchEdcById(paramEdcId)
                    if (!res3) return

                    let data = res3.data

                    setBankId(String(data.bankId))
                    setEdcName(data.edcName)
                    setMdrOff(data.mdrOff)
                    setMdrOn(data.mdrOn)
                    setMdrQrisOn(data.mdrQrisOn)
                    setMdrQrisOff(data.mdrQrisOff)
                    setBeneficiaryOptions([{label: data.beneficiaryName + " - " + data.bankCode + " (" + data.accountNo + ")", value: data.beneficiaryId}])
                    setBeneficiaryId({label: data.beneficiaryName + " - " + data.bankCode + " (" + data.accountNo + ")", value: data.beneficiaryId})
                    setEdcType(data.type)
                    setStatus(data.status)
                    setCreateDate(data.createDate)
                    setUpdateDate(data.updateDate)
                    setUpdateBy(data.updateBy)
                }
            } finally {
                hideLoading()
            }
        }

        loadData()
    }, [])

    return (
        <div className="flex flex-col gap-2">
            <PagesFormTitle 
                title='EDC Detail'
                formType={formType}
                status={status}
                createDate={createDate}
                updateDate={updateDate}
                updateBy={updateBy}
            />

            <div className="mt-5 flex flex-col gap-3">
                <FormCard title='Bank'>
                    <Dropdown value={bankId} options={bankOptions} onChange={(e) => setBankId(e.value)} />
                </FormCard>

                <FormCard title='EDC Name'>
                    <input className="input" value={edcName} onChange={(e) => setEdcName(e.target.value)} />
                </FormCard>
                
                <FormCard title='Beneficiary Account'>
                    <Select options={beneficiaryOptions} onInputChange={beneficiaryOnInput} value={beneficiaryId} onChange={(e) => setBeneficiaryId(e)} />
                </FormCard>
                
                <FormCard title='MDR On Us'>
                    <input className="input" value={mdrOn} onChange={ (e) => setMdrOn(decimal(e.target.value)) } />
                </FormCard>
                
                <FormCard title='MDR Off Us'>
                    <input className="input" value={mdrOff} onChange={ (e) => setMdrOff(decimal(e.target.value)) } />
                </FormCard>

                <FormCard title='MDR Qris On Us'>
                    <input className="input" value={mdrQrisOn} onChange={ (e) => setMdrQrisOn(decimal(e.target.value)) } />
                </FormCard>

                <FormCard title='MDR Qris Off Us'>
                    <input className="input" value={mdrQrisOff} onChange={ (e) => setMdrQrisOff(decimal(e.target.value)) } />
                </FormCard>

                <FormCard title='Type'>
                    <Dropdown value={edcType} options={edcTypeOptions} onChange={(e) => { setEdcType(e.value) }} />
                </FormCard>                

                <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                    <SaveButton onClick={saveBtnClick} visible={true} />
                    <DeleteButton onClick={deleteBtnClick} visible={ formType === FormTypeAdd ? false : (status === StatusCodeActive ? true : false) } />
                    <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === StatusCodeDelete ? true : false) : false} />
                    <BackButton onClick={backBtnClick}  />
                </div>
            </div>
        </div>
    )
}